<template>
  <RouteListItem :node="{
    name: node.name,
    children: isAdmin ? assignments : [],
    meta: {
      displayName: isAdmin ? $t('servicesystem.pages.page_titles.job_assignments') : $t('servicesystem.pages.page_titles.job_my_jobs'),
      icon: isAdmin ? 'mdi-account-group' : 'mdi-briefcase-account',
      count: isAdmin ? 0 : myUserCount,
      params: {
        filter: `my`,
      }
    }
  }" :openfunc="() => { return ($route.name == node.name && $route.params.filter == 'y') }" @open="refreshMap()">

    <template v-if="isAdmin" slot="children">
      <v-progress-linear v-if="loading" indeterminate height="1">
      </v-progress-linear>
      <RouteListItem :key="myUserId" :node="{
        name: node.name,
        meta: {
          displayName: $t('servicesystem.pages.page_titles.job_my_jobs'),
          count: myUserCount,
          params: { filter: `my` },
        }
      }">
        <template slot="icon">
          <avatar :color="'red'" :fullname="userInfo.Name" :xSmall="true">
          </avatar>
        </template>
      </RouteListItem>

      <RouteListItem v-for="user in othersAssignments" :key="user.Id" :node="{
        name: node.name,
        meta: {
          displayName: user.Name,
          count: user.Count,
          params: { filter: `user-${user.Id}` },
        }
      }">
        <template slot="icon">
          <avatar :color="getUserTypeColor(user.UserTypeId)" :fullname="user.Name" :xSmall="true">
          </avatar>
        </template>
      </RouteListItem>
    </template>
  </RouteListItem>
</template>


<script>
import RouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Base.vue";
import Avatar from "@/components/Buttons/Avatar.vue";
import UserTypeMixin from "@/helpers/Mixins/UserTypeMixin";

export default {
  name: "RouteListItem_Status",
  props: {
    status: Object,
    node: Object,
  },
  components: {
    RouteListItem,
    Avatar,
  },
  mixins: [UserTypeMixin],

  data() {
    return {
      resourceList: []
    };
  },

  methods: {
    refreshMap() {
      this.$store.dispatch("BackgroundUpdater/Checker", "AssignmentMap");
    },
  },

  computed: {
    loading() {
      return this.$store.getters["BackgroundUpdater/Loading"]("AssignmentMap");
    },
    assignments() {
      return this.$store.getters["LookUpStore/AssignmentMap"] ?? [];
    },
    othersAssignments() {
      return this.assignments?.filter(item => item.Id != this.myUserId);
    },

    myUserId() {
      return this.userInfo.Id;
    },
    myUserType() {
      return this.userInfo.UserTypeId;
    },
    isAdmin() {
      return this.myUserType === 1;
    },

    myUserCount() {
      return this.assignments.find(item => item.Id === this.myUserId)?.Count || 0;
    },
  },

  watch: {
    isAdmin() {
      this.getResources();
    },
  },
};
</script>


<style lang='scss' scoped>
.liftup10 {
  z-index: 10;
}
</style>